import React, { useEffect, useState, useCallback, memo } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import pinIcon from "../../images/foot3.svg";
import { Branch } from "./locations";

type BranchesMapProps = {
  markersData: Array<Branch>;
};

function BranchesMap(props: BranchesMapProps) {
  const getInitialZoom = () => window.innerWidth / 800;
  const [zoom, setZoom] = useState(getInitialZoom());
  useEffect(() => {
    setZoom(getInitialZoom());
  }, []);
  const containerStyle = { width: "400px", height: "400px" };
  const center = { lat: 28, lng: 30 };
  const { isLoaded } = useJsApiLoader({
    id: "b80729ed38058710",
    googleMapsApiKey: "AIzaSyC4SABdj4OIWCRomzLnRCAWm7oqF1PBczY",
  });

  return isLoaded ? (
    <GoogleMap
      // mapId="b80729ed38058710"
      mapContainerStyle={{ width: "100%", height: "100%" }}
      center={{ lat: 28, lng: 30 }}
      zoom={zoom}
      // clickableIcons = {true}
      options={{
        disableDefaultUI: true,
        zoomControl: true,
      }}
    >
      {props.markersData.map((markerData, i) => {
        const coordsString = markerData.rough_coords;
        if (!coordsString) return null;
        const [lat, lng] = coordsString
          .split(",")
          .map((coord) => parseFloat(coord.trim()));

        return (
          <Marker
            key={i}
            position={{ lat: lat, lng: lng }}
            icon={pinIcon}
            onClick={() => {
              alert(markerData.label);
            }}
          />
        );
      })}
    </GoogleMap>
  ) : (
    <></>
  );
}

export default memo(BranchesMap);
